const PREFIX = "app/map/";

export const MAP_SET = `${PREFIX}set`;
export const MAP_SHOW = `${PREFIX}show`;
export const MAP_HIDE = `${PREFIX}hide`;
export const MAP_CLEAR = `${PREFIX}clear`;
export const MAP_CLEAR_OPTIONS = `${PREFIX}clearOptions`;
